import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconFileTypeDocx = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7 4a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h7a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v4a1 1 0 1 1-2 0V9h-3a2 2 0 0 1-2-2V4zm8 1.414L16.586 7H15zm4.053 8.692a1 1 0 0 1 1.341.447l.606 1.21.606-1.21a1 1 0 1 1 1.788.894L22.118 18l1.276 2.553a1 1 0 1 1-1.788.894L21 20.237l-.606 1.21a1 1 0 1 1-1.788-.894L19.882 18l-1.276-2.553a1 1 0 0 1 .447-1.341M1 15a1 1 0 0 1 1-1h1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H2a1 1 0 0 1-1-1zm2 1v4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m6.5 0a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5m-1.768-1.268A2.5 2.5 0 0 1 12 16.5v3a2.5 2.5 0 0 1-5 0v-3a2.5 2.5 0 0 1 .732-1.768m6 0A2.5 2.5 0 0 1 18 16.5a1 1 0 1 1-2 0 .5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0 1 1 0 1 1 2 0 2.5 2.5 0 0 1-5 0v-3a2.5 2.5 0 0 1 .732-1.768"
            clipRule="evenodd"
        />
    </svg>
);
